// extracted by mini-css-extract-plugin
module.exports = {"toggleGroup":"periodToggler_toggleGroup__2w1ee","toggleBtn":"periodToggler_toggleBtn__3HdOi","selected":"periodToggler_selected__1hBY1"};